import ShareholderInfo from './container';

export default ShareholderInfo;
